export default {
  女装: "Mavazi ya wanawake",
  男装: "Wanaume",
  手机和小工具: "Simu ya rununu na zana ndogo",
  居家生活: "Maisha ya nyumbani",
  电脑及周边设备: "Vifaa vya kompyuta na pembeni",
  美容及个人护理: "Uzuri na utunzaji wa kibinafsi",
  家用电器: "Vifaa",
  健康与保健: "Huduma ya afya na afya",
  食品和饮料: "Chakula na vinywaji",
  玩具_儿童和婴儿: "Toys, watoto na watoto",
  童装时尚: "Mtindo wa mavazi ya watoto",
  视频游戏: "michezo ya video",
  运动与户外: "Mazoezi na nje",
  爱好与书籍: "Hobbies na vitabu",
  相机和无人机: "Kamera na drones",
  宠物食品及用品: "Chakula cha pet na vifaa",
  女士包袋: "Begi la wanawake",
  男士包袋: "Mfuko wa Wanaume",
  珠宝及配饰: "Vito vya mapambo na vifaa",
  手表: "Tazama",
  女鞋: "Viatu vya wanawake",
  男装鞋: "Viatu vya wanaume",
  汽车: "gari",
  我附近的ShopeePay: "Duka langu la karibu",
  餐饮_旅行和服务: "Upishi, kusafiri na huduma",
  旅行及行李: "Kusafiri na mzigo",
  各种各样的: "Anuwai",
  我是来买什么的: "Niko hapa kununua",
  对不起_找不到_相关的商品:
    "Samahani, huwezi kupata bidhaa zinazohusiana na [{0}]",
  类别: "Jamii",
  产品: "Bidhaa",
  店铺: "Duka",
  首页: "Ukurasa wa mbele",
  限时秒杀: "Spike ya muda mdogo",
  博客: "Blogi",
  所有品牌: "Bidhaa zote",
  所有类别: "Aina zote",
  我的购物车: "Gari langu la ununuzi",
  发货信息: "Habari ya Uwasilishaji",
  交货信息: "Habari ya Uwasilishaji",
  付款: "Malipo",
  确认: "Thibitisha",
  您的购物车是空的: "Gari lako la ununuzi halina kitu",
  价格: "bei",
  税: "Ushuru",
  数量: "wingi",
  总计: "Jumla",
  移除: "Ondoa",
  返回商店: "Kurudi dukani",
  继续发货: "Endelea kujifungua",
  筛选: "Kichujio",
  价格范围: "Bei",
  排序方式: "Panga na",
  最新: "hadi sasa",
  最旧: "Mzee",
  价格从低到高: "Bei kutoka chini hadi juu",
  价格从高到低: "Bei kutoka juu hadi chini",
  选择交货类型: "Chagua Aina ya Uwasilishaji",
  送货上门: "Utoaji",
  继续付款: "Endelea kulipa",
  任何其他信息: "Habari nyingine yoyote",
  或者: "au",
  您的钱包余额: "Usawa wako wa mkoba",
  余额不足: "Usawa wa kutosha",
  支付: "Lipa",
  我同意: "Nakubali",
  条款和条件: "Masharti na Masharti",
  退货政策: "sera ya kurudi",
  隐私政策: "Faragha",
  概括: "Jumla",
  项目: "Mradi",
  全部的: "Zote",
  小计: "Mchoro",
  总运费: "Jumla ya mizigo",
  有优惠码吗_在这里输入: "Je! Kuna nambari ya punguzo? Ingiza hapa",
  申请: "Omba",
  编辑: "hariri",
  删除: "Futa",
  添加新地址: "Ongeza anwani mpya",
  继续交货信息: "Endelea habari ya utoaji",
  选择一个地址: "Chagua anwani",
  购买历史: "Nunua Historia",
  下载: "Pakua",
  已发送退款请求: "Ombi la kurudishiwa hutuma ombi la kurejesha",
  对比: "Tofauti",
  对话: "mazungumzo",
  我的钱包: "Mkoba wangu",
  工单: "Agizo la kazi",
  管理个人资料: "Dhibiti habari za kibinafsi",
  登出: "Saini",
  重置对比列表: "Rudisha orodha ya kulinganisha",
  您的对比列表为空: "Orodha yako ya kulinganisha haina kitu",
  在您的购物车中: "Katika gari lako la ununuzi",
  在您的愿望清单中: "Katika orodha yako ya matakwa",
  在您的预定列表中: "Katika orodha yako iliyopangwa",
  下载您的产品: "Pakua bidhaa yako",
  选项: "Chaguo",
  什么都没找到: "Sikupata chochote",
  特色产品: "Bidhaa maalum",
  最畅销: "Bora",
  前_名: "Jina la awali {0}",
  查看更多: "Tazama zaidi",
  查看所有类别: "Angalia aina zote",
  十大品牌: "Bidhaa kumi za juu",
  查看所有品牌: "Angalia chapa zote",
  登录: "Ingia",
  手机号码: "Nambari ya simu",
  密码: "Nenosiri",
  密码长度为6到16个字符: "Urefu wa nywila ni herufi 6 hadi 16",
  验证码: "Nambari ya uthibitisho",
  登录中: "Ingia",
  游客登录: "Kuingia kwa watalii",
  注册您的商店: "Sajili duka lako",
  现在申请: "Omba sasa",
  成为商家: "Kuwa mfanyabiashara",
  现在注册: "Jisajili sasa",
  登录成功: "Kuingia kwa mafanikio",
  通知: "Arifu",
  未找到通知: "Hakuna arifa",
  评论: "Maoni",
  估计运输时间: "Wakati uliokadiriwa wa usafirishaji",
  天: "Anga",
  所售: "Uuzaji",
  给商家留言: "Acha ujumbe kwa mfanyabiashara",
  规格: "Uainishaji",
  库存: "katika hisa",
  总价: "Bei ya jumla",
  添加到购物车: "Ongeza kwenye gari",
  立即购买: "Nunua sasa",
  缺货: "nje ya hisa",
  添加到愿望清单: "Ongeza kwenye orodha ya matakwa",
  加入对比列表: "Ongeza orodha ya kulinganisha",
  退款: "Malipo",
  查看条款: "Tazama kifungu",
  分享: "Shiriki",
  描述: "Fafanua",
  相关产品: "Bidhaa zinazohusiana",
  没有人问过商家: "Hakuna mtu aliyemwuliza mfanyabiashara",
  该产品暂无评论: "Hakuna maoni juu ya bidhaa hii",
  客户评论: "Maoni ya Wateja",
  访问商店: "Tembelea duka",
  畅销产品: "Bidhaa bora zaidi",
  日期: "tarehe",
  订单编号: "Nambari ya agizo",
  总额: "jumla ya donge",
  状态: "jimbo",
  愿望清单: "Orodha ya matakwa",
  还没有添加任何东西: "Bado haujaongeza chochote",
  注册: "Jisajili",
  邀请码: "Nambari ya mwaliko",
  请输入邀请码: "Tafadhali ingiza nambari ya mwaliko",
  用户名: "Jina la mtumiaji",
  请输入用户名: "Tafadhali ingiza jina la mtumiaji",
  用户名长度为6_14个字符: "Urefu wa jina la mtumiaji ni herufi 6-14",
  昵称: "Jina la Nick",
  请输入手机号码: "Tafadhali ingiza nambari ya simu ya rununu",
  手机号码格式错误: "Kosa la muundo wa nambari ya simu ya rununu",
  密码长度为6_16个字符: "Urefu wa nywila ni herufi 6-16",
  确认密码: "Thibitisha nywila",
  请输入确认密码: "Tafadhali ingiza nywila ya uthibitisho",
  提款密码: "Nenosiri la kujiondoa",
  请输入提款密码: "Tafadhali ingiza nywila ya kujiondoa",
  提款密码长度为4_16个字符: "Urefu wa nywila ya kujiondoa ni herufi 4-16",
  请输入验证码: "Tafadhali ingiza nambari ya uthibitisho",
  在_s后发送: "Tuma baada ya {0} s",
  发送验证码: "Tuma nambari ya uthibitisho",
  注册即表示您同意我们的条款和条件:
    "Usajili unamaanisha kuwa unakubaliana na sheria na masharti yetu.",
  创建账号: "Unda akaunti",
  验证码发送成功: "Nambari ya uthibitishaji hutuma kwa mafanikio",
  确认密码不一致: "Thibitisha kuwa nywila haiendani",
  提款密码必须为数字: "Nenosiri la kujiondoa lazima lihesabiwe",
  注册成功: "Jisajili kwa mafanikio",
  购物车: "Gari la ununuzi",
  账户: "Akaunti",
  我的账户: "Akaunti yangu",
  已经有一个账户: "Tayari unayo akaunti",
  新地址: "Anwani mpya",
  编辑地址: "Anwani ya Mhariri",
  保存: "kuokoa",
  是否默认: "Ikiwa ni chaguo -msingi",
  具体地址: "Anwani maalum",
  请输入具体地址: "Tafadhali ingiza anwani maalum",
  地区: "eneo",
  请输入地区: "Tafadhali ingiza eneo hilo",
  城市: "Mji",
  请输入城市: "Tafadhali ingiza jiji",
  省份: "mkoa",
  请输入省份: "Tafadhali ingiza mkoa",
  邮政编码: "Nambari ya Posta",
  请输入邮政编码: "Tafadhali ingiza nambari ya posta",
  电话号码: "nambari ya simu",
  请输入电话号码: "Tafadhali ingiza nambari ya simu",
  收货人: "consignee",
  请输入收货人: "Tafadhali ingiza mjumbe",
  保存成功: "Kufanikiwa",
  最畅销的商家: "Mfanyabiashara bora zaidi",
  查看所有的商家: "Angalia wafanyabiashara wote",
  支持政策: "Sera ya msaada",
  您的电子邮件地址: "Anwani yako ya barua pepe",
  订阅: "usajili",
  联系方式: "Maelezo ya mawasiliano",
  地址: "Anwani",
  美国伊利诺伊州霍夫曼庄园: "Holfman Manor, Illinois, USA",
  快速链接: "Kiungo cha haraka",
  商家政策: "Sera ya wafanyabiashara",
  submit: "wasilisha",
  提款银行卡: "Kadi ya ADBB",
  我的面板: "Jopo langu",
  提示: "dokezo",
  确定登出吗: "Je! Una uhakika unaingia?",
  确定: "Hakika",
  取消: "Ghairi",
  项目添加到您的购物车: "Mradi unaongezwa kwenye gari lako la ununuzi",
  经常一起购买: "Nunua mara kwa mara",
  返回购物: "Kurudi ununuzi",
  进行结算: "endelea kukagua",
  帮助热线: "Saidia Hotline",
  查看所有通知: "Angalia arifa zote",
  请输入密码: "Tafadhali ingiza nywila",
  前往充值: "Nenda kwa recharge",
  购物车物品: "Gari la ununuzi",
  查看购物车: "Angalia gari la ununuzi",
  钱包余额: "Mizani ya mkoba",
  充值钱包: "Mfuko wa Recharge",
  钱包充值_线下_: "Recharge ya mkoba (nje ya mkondo)",
  申请提款: "Omba uondoaji",
  钱包收支明细: "Mapato ya mkoba na maelezo ya matumizi",
  批准: "Idhini",
  提现历史记录: "Rekodi ya kihistoria ya kuajiri",
  类型: "aina",
  信息: "habari",
  付款方式: "Njia ya malipo",
  请选择付款方式: "Tafadhali chagua njia ya malipo",
  Bill_Type_RECHARGE_BACK: "Recharge ya nyuma",
  Bill_Type_RECHARGE_ONLINE: "Recharge mkondoni",
  Bill_Type_RECHARGE_REGISTER: "Jisajili",
  Bill_Type_RECHARGE_JACKPOT: "Recharge",
  Bill_Type_RECHARGE_PRESENT: "Malipo ya recharge",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Uhamisho wa Tume",
  Bill_Type_RECHARGE_TG_COMMISSION: "Tume ya kukuza tena",
  Bill_Type_REGISTER_TG_COMMISSION: "Sajili na Tume ya Ukuzaji",
  Bill_Type_WITHDRAW: "Kujiondoa",
  Bill_Type_WITHDRAW_REJECT: "Kujiondoa",
  Bill_Type_DEDUCT_HANDLE: "Kupunguzwa kwa mwongozo",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Recharge",
  Bill_Type_MINING_PROFIT: "Mapato ya madini",
  Bill_Type_MINING_PROFIT_COMMISSION: "Tume ya kukuza mapato ya madini",
  Bill_Type_VIP_UPGRADE: "Boresha VIP",
  Bill_Type_FINANCE_BUY: "Ununuzi wa bidhaa za usimamizi wa mali",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Kurudi kwa usawa wa kifedha",
  Bill_Type_FINANCE_FEE: "Ada ya utunzaji wa kifedha",
  Bill_Type_FINANCE_PROFIT: "Mapato ya kifedha",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Tume za ununuzi wa bidhaa za usimamizi wa mali",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "Tume ya Mapato ya Bidhaa ya Usimamizi",
  Bill_Type_WHEEL_DRAW: "Big turntable raffle",
  Bill_Type_BUY: "Nunua bidhaa",
  Bill_Type_PAY_SHOP: "Malipo ya ada ya utoaji",
  Bill_Type_BUY_COMMISSION: "Nunua Tume ya Bidhaa",
  Bill_Type_DEPOSIT: "Lipa amana",
  Bill_Type_STORE_BUY: "Nunua bidhaa",
  Bill_Type_STORE_BUY_REFUND: "Nunua marejesho",
  Bill_Type: "Aina ya mabadiliko ya deni",
  Before_Money: "Kiasi cha awali",
  Deal_Money: "Kiwango cha mabadiliko ya akaunti",
  After_Money: "Kiasi kinachofuata",
  Bill_Time: "Wakati wa mabadiliko ya akaunti",
  No_More_Data: "Hakuna data zaidi",
  Apply_Money: "Kiasi cha Maombi",
  Apply_Time: "Wakati wa maombi",
  Withdraw_Info: "Ada ya utunzaji: {ada}, kwa akaunti: {pesa}",
  提款订单状态_CHECKING: "Kukaguliwa",
  提款订单状态_TRANSFERRING: "Uhamisho",
  提款订单状态_PASS: "Thibitisha",
  提款订单状态_REJECT: "Kukataliwa",
  暂无可用充值方式: "Hakuna njia muhimu ya recharge",
  钱包收款码: "Nambari ya ukusanyaji wa mkoba",
  钱包地址: "Anwani ya mkoba",
  金额限制: "Kiwango cha Kiwango",
  复制: "Nakala",
  付款凭证: "Vocha ya malipo",
  收款银行: "Benki inayopatikana",
  收款人: "Cashier",
  收款账号: "Akaunti ya risiti",
  付款银行: "Lipa benki",
  付款人: "Mlipaji",
  付款账号: "Akaunti ya Malipo",
  请输入付款银行: "Tafadhali ingiza benki ya malipo",
  请输入付款人: "Tafadhali ingiza mlipaji",
  请输入付款账号: "Tafadhali ingiza akaunti ya malipo",
  请上传付款凭证: "Tafadhali pakia vocha za malipo",
  充值金额: "Kiasi cha recharge",
  请输入充值金额: "Tafadhali ingiza kiasi cha recharge",
  submitting: "Iliyowasilishwa ...",
  Confirm: "wasilisha",
  Commit_Success: "Uwasilishaji mzuri",
  balanceType_BALANCE: "Usawa",
  balanceType_COMMISSION: "tume",
  Balance: "Usawa wa akaunti",
  Wash_Money: "Coding",
  请选择银行账户: "Tafadhali chagua akaunti ya benki",
  卡号类型: "Nambari ya kadi",
  提现金额: "Kiasi cha kujiondoa",
  提款金额: "Kiasi cha kujiondoa",
  不能为空: "Haiwezi kuwa tupu",
  金额不正确: "Kiasi kisicho sahihi",
  please_input_withdraw_password: "Tafadhali ingiza nywila ya kujiondoa",
  withdraw_password_format_error:
    "Nenosiri la kujiondoa lazima liwe wahusika 4-16-bit",
  Fee: "Ada ya utunzaji",
  实际到账: "Kweli",
  交易币种: "Sarafu ya biashara",
  原始密码: "Nenosiri la zamani",
  confirm_password_error: "Nenosiri katika pembejeo mbili sio sahihi",
  save_success: "Kufanikiwa",
  please_input: "Tafadhali ingiza",
  old_password: "Nywila ya zamani",
  new_password: "Nywila mpya",
  please_input_confirm_password: "Tafadhali thibitisha nenosiri tena",
  没有找到符合条件的商品: "Haiwezi kupata bidhaa zilizohitimu",
  Search: "tafuta",
  全部: "Zote",
  EnumGoodsOrderState_USER_PAY: "Kusambazwa",
  EnumGoodsOrderState_SHOP_PAY: "Usambazaji",
  EnumGoodsOrderState_SUCCESS: "Maliza",
  EnumGoodsOrderState_CANCEL: "Ghairi",
  EnumGoodsOrderState_REFUND_SUCCESS: "Malipo",
  订单号: "Nambari ya agizo",
  用户名称: "Jina la Mtumiaji",
  收益: "mapato",
  支付时间: "Lipa wakati",
  配送时间: "Wakati wa kujifungua",
  完成时间: "Wakati kamili",
  发货: "Meli",
  全选: "Uteuzi kamili",
  物品已添加到愿望清单: "Vitu vimeongezwa kwenye orodha ya matakwa",
  物品已添加到比较列表: "Vitu vimeongezwa kwenye orodha ya kulinganisha",
  购买成功提示: "Hongera, kwa mafanikio kununua",
  订单列表: "Orodha ya Agizo",
  商品名: "Jina la bidhaa",
  图片: "picha",
  没有品牌: "Hakuna chapa",
  基本信息: "Habari ya msingi",
  Account_Name: "Jina",
  Bank_Account: "Akaunti ya benki",
  Bank_Phone: "Hifadhi nambari ya simu ya rununu",
  IFSC: "Akaunti ya IFSC",
  UPI: "Akaunti ya UPI",
  PIX: "Nambari ya akaunti ya pix",
  CPF: "Akaunti ya CPF",
  GCASH: "Akaunti ya GCASH",
  POWWI: "Akaunti ya Powwi",
  身份证号: "Nambari ya kitambulisho",
  Edit: "Rekebisha",
  Delete: "Futa",
  Add: "Ongezeko",
  Forget_Withdraw_Password: "Kusahau na nywila ya kujiondoa",
  Bank_Card_Info: "Habari ya kadi ya benki",
  收款人地址: "Anwani ya cashier",
  SWIFT: "Mwepesi",
  Bank_Branch: "Jina ndogo la Branch",
  分行代码: "Nambari ya tawi",
  银行地址: "Anwani ya benki",
  Email: "Barua pepe",
  银行卡长度必须超过: "Urefu wa kadi ya benki lazima uzidi {urefu}",
  银行卡格式不正确: "Fomati ya kadi ya benki sio sahihi",
  Do_you_confirm_delete: "Je! Unathibitisha kufuta?",
  Please_Login_First: "Tafadhali ingia kwanza",
  Bank_Name: "Jina la benki",
  Please_add_bank_first: "Haujafunga kadi ya benki, tafadhali ongeza kwanza",
  withdrawType: "Kujiondoa",
  withdraw_money_limit:
    "Kiasi cha kujiondoa lazima iwe kubwa kuliko 0 na chini ya au sawa na {usawa}",
  withdraw_times_limit:
    "Umetoa nyakati za {leoWithDrawnum} leo. Je! Imedhamiriwa kuondoa pesa?",
  Copy_Success: "Replication",
  商店首页: "Hifadhi ukurasa wa nyumbani",
  所有产品: "Bidhaa zote",
  新到货产品: "Bidhaa mpya ya uandikishaji",
  所有商家: "Wafanyabiashara wote",
  请上传: "Tafadhali pakia",
  请输入: "Tafadhali ingiza",
  忘记密码: "Sahau nywila",
  记得我: "Nikumbuke",
  共_件: "Jumla ya {0} kipande",
  取消订单: "Ghairi agizo",
  申请退款: "Omba kwa marejesho",
  未知商家: "Mfanyabiashara asiyejulikana",
  到账: "Akaunti",
  提款订单状态: "Hali ya agizo la kujiondoa",
  前_名类别: "Jamii ya kwanza {0}",
  取消订单原因_不想要了: "Hawataki tena",
  取消订单原因_商品错选_多选: "Makosa ya bidhaa/chaguo nyingi",
  取消订单原因_商品无货: "Nje -of -goods",
  取消订单原因_地址信息填写错误: "Jaza kosa la habari ya anwani",
  取消订单原因_商品降价: "Kupunguza bei ya bidhaa",
  取消订单原因_价格高于其他平台: "Bei ni kubwa kuliko majukwaa mengine",
  取消订单原因_没用_少用_错用优惠: "Hakuna/tumia punguzo la chini/kosa",
  退款原因_拍错_多拍_不喜欢: "Chukua vibaya/risasi zaidi/usipende",
  退款原因_商品成分描述不符: "Maelezo ya sehemu ya bidhaa hayalingani",
  退款原因_与商家协商一致退款: "Mashauriano na marejesho ya mfanyabiashara",
  退款原因_生产日期_保质期与商品描述不符:
    "Tarehe ya uzalishaji/maisha ya rafu hailingani na maelezo ya bidhaa",
  退款原因_图片_产地_批号_规格等描述不符:
    "Picha/Mahali pa Asili/Nambari ya Batch/Uainishaji, nk.",
  退款原因_质量问题: "Suala la ubora",
  退款原因_商品变质_发霉_有异物: "Bidhaa nyara/ukungu/mwili wa kigeni",
  退款原因_少件_含缺少配件_: "Vitu vidogo (pamoja na ukosefu wa vifaa)",
  退款原因_收到商品时有破损_污渍_变形:
    "Wakati wa kupokea bidhaa, kuna uharibifu/doa/deformation",
  退款原因_假冒品牌: "Bandia",
  退款原因_发票问题: "Shida ya ankara",
  退款原因_商家发错货: "Wafanyabiashara hutuma bidhaa zisizo sawa",
  退款原因_预约不到_商家不给退换:
    "Haiwezi kufanya miadi/mfanyabiashara haitarudishwa",
  退款失败: "Kushindwa kwa kurudishiwa",
  退款处理中: "Usindikaji wa marejesho",
  默认: "Chaguo -msingi",
  产品查询: "Swala la bidhaa",
  商店LOGO: "Nembo ya duka",
  推广码: "Nambari ya kukuza",
  查看所有: "Angalia yote",
  确认收货成功: "Thibitisha kuwa risiti imefanikiwa",
  物流公司: "Kampuni ya vifaa",
  物流单号: "Nambari ya agizo la vifaa",
  发货时间: "Wakati wa kujifungua",
  请先选择商品规格: "Tafadhali chagua maelezo ya bidhaa kwanza",
  个人信息: "Habari ya kibinafsi",
  您的用户名: "Jina lako la mtumiaji",
  你的名字: "Jina lako",
  登录名: "Jina la mtumiaji",
  你的邮件: "Barua yako",
  你的密码: "Nenosiri lako",
  重复输入密码: "Rudia nywila",
  店铺名称: "Jina la Duka",
  证书类型: "Aina",
  身份证: "Kadi ya kitambulisho",
  护照: "pasipoti",
  驾驶执照: "Leseni ya dereva",
  社会保障卡: "Kadi ya Usalama wa Jamii",
  证书正面: "Cheti chanya",
  证书反面: "Uthibitisho",
  确认收货: "Thibitisha kupokea bidhaa",
  请选择取消订单的原因必选:
    "Tafadhali chagua sababu ya kufuta agizo (inahitajika):",
  请选择申请退款的原因必选:
    "Tafadhali chagua sababu ya kuomba pesa (inahitajika):",
  留言: "Ujumbe",
  请输入留言: "Tafadhali ingiza ujumbe",
  没有帐户: "Hakuna akaunti",
  钱包充值: "Recharge ya mkoba",
  输入您的文字: "Ingiza maandishi yako",
  商家登录: "Kuingia kwa mfanyabiashara",
  有关此产品的任何查询: "Hoja yoyote kwenye bidhaa hii",
  产品名称: "Jina la bidhaa",
  你的问题: "Shida yako",
  白银店铺: "Duka la fedha",
  铂金店铺: "Duka la Platinamu",
  钻石店铺: "Duka la almasi",
  照片: "picha",
  已退货: "Alirudi",
  邮寄状态: "Hali ya barua",
  订单摘要: "Agizo la kuagiza",
  收件地址: "Anwani ya mapato",
  订购日期: "Tarehe ya agizo",
  订单状态: "Hali ya agizo",
  总订单金额: "Jumla ya agizo",
  邮寄方式: "Njia ya kutuma barua",
  附加信息: "Habari ya ziada",
  订单详细信息: "Habari ya kina",
  交货类型: "Aina ya utoaji",
  进行评论: "Maoni",
  已评论: "Alitoa maoni",
  订单金额: "Kiasi cha agizo",
  优惠券: "Coupon",
  统一运费: "Ushirikiano wa Umoja",
  送货地址: "Anwani ya usafirishaji",
  评分: "alama",
  你的意见: "Maoni yako",
  匿名: "Anonymous",
  现金: "Fedha",
  详情: "Undani",
  收货地址: "Anwani ya risiti",
  暂时没有对话: "Hakuna mazungumzo kwa wakati huu",
  你: "wewe",
  输入您的回复: "Ingiza jibu lako",
  删除成功: "Futa",
  品牌: "chapa",
  已缴纳的保证金: "Kulipwa kiasi",
  黄金店铺: "Duka la Dhahabu",
  没有更多数据: "Hakuna data zaidi",
  站内信: "Barua ya juu",
  系统通知: "Arifa ya Mfumo",
  邮箱: "Barua",
  手机号: "Nambari ya simu",
  你的手机号: "Nambari yako ya simu ya rununu",
  营业执照: "Leseni ya biashara",
  你的邮箱: "Sanduku lako la barua",
  搜索结果: "Matokeo ya utaftaji",
  系统公告: "Tangazo la mfumo",
  客服: "Huduma ya Wateja",
  消息已撤回: "Habari zimeondolewa",
  物流详情: "Maelezo ya vifaa",
  充值: "Juu juu",
  提现: "Kujiondoa",
  信用分: "Mikopo",
  余额: "Usawa",
  佣金: "tume",
  继续购物: "Endelea kununua",
  订单结算: "Makazi ya agizo",
  加入对比: "Ongeza kulinganisha",
  佣金余额: "Mizani ya Tume",
  刷新: "Refresh",
  刷新成功: "Refresh",
  官网: "Tovuti rasmi",
  税号: "Nambari ya ushuru",
  订单: "Agizo",
  合计: "Jumla",
  系统安全: "Usalama wa mfumo",
  Recharge_Money_Limit: "Kiasi cha recharge lazima iwe kati ya {min} na {max}",
  限时优惠: "Wakati mdogo",
  高价回收: "Kusindika kwa kiwango cha juu",
  姓名: "Jina",
  商品订单号: "Nambari ya agizo la bidhaa",
  商品在线回收: "Bidhaa za kuchakata mtandaoni",
  提交: "wasilisha",
  回收记录: "Rekodi ya uokoaji",
  回收状态: "Hali ya uokoaji",
  回收价格: "Bei ya kuchakata",
  纳税码: "Nambari ya Ushuru",
  买家登录: "Ingia",
  买家注册: "Jisajili",
  language: "Kichina",
  助力提示:
    "Kusaidia wafanyabiashara kunaweza kuongeza mfiduo wa jukwaa kwa duka zao, na idadi kubwa ya siku, juu ya mfiduo.",
  已累计助力: "Kusaidiwa kwa makusudi",
  今日已助力: "Leo imesaidia",
  立即助力: "Saidia mara moja",
  商家助力: "Msaada wa wafanyabiashara",
  证件号码: "Nambari ya kitambulisho",
  证书号码: "Nambari ya cheti"
};
